import React from 'react';
import './App.css';
import ParticleSystem from './ParticleSystem';
import GestureInterface from './GestureInterface';

function App() {
  return (
    <div className="App">
      <ParticleSystem />
      <GestureInterface />
    </div>
  );
}

export default App;
